// Local development only:
// const ApiURl = "http://localhost/cv-aman/cv/backend/";

const ApiURl = "https://talencar.com/backend/";

export default ApiURl;

